/**
 * Format error messages for user display
 */
export function formatErrorMessage(error) {
  // Handle Firebase errors
  if (error.code) {
    switch (error.code) {
      case 'auth/requires-recent-login':
        return 'Du måste bekräfta inloggningen igen (t.ex. med lösenord) innan du kan ändra säkerhetsinställningar.';
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        return 'Fel lösenord. Försök igen.';
      case 'auth/too-many-requests':
        return 'För många försök. Vänta en stund och försök igen.';
      case 'auth/no-email-password':
        return error.message || 'Lösenordsbekräftelse är inte tillgänglig för detta konto.';
      case 'auth/missing-password':
        return error.message || 'Ange ditt lösenord.';
      case 'auth/popup-closed-by-user':
        return 'Inloggsfönstret stängdes. Försök igen.';
      case 'auth/account-exists-with-different-credential':
        return 'Det finns redan ett konto med den här e-postadressen med annan inloggning. Logga in med e-post och lösenord.';
      case 'unauthenticated':
        return 'Du är inte inloggad. Vänligen logga in igen.';
      case 'permission-denied':
        return 'Du har inte behörighet att utföra denna åtgärd.';
      case 'failed-precondition':
        return error.message || 'Förutsättningar saknas. Vänligen kontrollera din Fortnox-anslutning.';
      case 'invalid-argument':
        return error.message || 'Ogiltiga parametrar. Vänligen försök igen.';
      case 'internal':
        return 'Ett internt fel uppstod. Vänligen försök igen senare.';
      default:
        return error.message || 'Ett oväntat fel uppstod.';
    }
  }
  
  // Handle network errors
  if (error.message?.includes('network') || error.message?.includes('fetch')) {
    return 'Nätverksfel. Kontrollera din internetanslutning och försök igen.';
  }
  
  // Handle Fortnox-specific errors
  if (error.message?.includes('Fortnox')) {
    if (error.message?.includes('expired') || error.message?.includes('token')) {
      return 'Din Fortnox-anslutning har gått ut. Vänligen återanslut ditt konto.';
    }
    if (error.message?.includes('rate limit')) {
      return 'För många förfrågningar. Vänligen vänta en stund och försök igen.';
    }
    return error.message || 'Ett fel uppstod vid kommunikation med Fortnox.';
  }
  
  // Default
  return error.message || 'Ett oväntat fel uppstod. Vänligen försök igen.';
}

/**
 * Log error with context
 */
export function logError(error, context = {}) {
  console.error('Error:', {
    message: error.message,
    code: error.code,
    stack: error.stack,
    context,
    timestamp: new Date().toISOString(),
  });
}
